// extracted by mini-css-extract-plugin
export var blogNavMegaShrink = "blog-header-module--blog-nav-mega-shrink--01bcc";
export var blogNavMegaTopShrink = "blog-header-module--blog-nav-mega-top-shrink--69281";
export var blogSearchForm = "blog-header-module--blog-search-form--aa933";
export var mobileSearchForm = "blog-header-module--mobile-search-form--a94f7";
export var searchBar = "blog-header-module--search-bar--1caa4";